



















































































































import Vue from "vue";
import { mapState } from "vuex";
import { get } from "@/api";

import CashDocumentsTable from "./CashDocumentsTable.vue";
import store from "@/store";
import { formatCurrency } from "../../../src/utils";

export default Vue.extend({
  name: "PaymentsCollected",
  components: {
    CashDocumentsTable,
  },
  data() {
    return {
      isLoading: true, // Loading flag
      walletSummary: {
        totalCredit: 0, // Total Collected
        totalDebit: 0, // Total Deposited
        balance: 0,
        previousBalance: 0, // Yet to Be Deposited
      },
      clientId: null,
    };
  },
  methods: {
    formatCurrency,
    navigateToViewLogs() {
      (this as any).$router
        .push({
          path: `/transactions/cash-documents/viewlogs`,
        })
        .catch((err: any) => {
          if (err.name !== "NavigationDuplicated") {
            // TODO
            /** Handle this */
            /** Show message to user if it is required */
            // console.error(err);
          }
        });
    },
    formatDate(date: any) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    fetchSummary() {
      (this as any).isLoading = true;
      (this as any).$store.commit("uiModule/showLoadingModal", null, { root: true });
      const today = new Date();
      const startOfCurrentMonth = new Date(
        today.getFullYear(),
        today.getMonth(),
        1
      );
      const endOfCurrentMonth = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        0
      );
      const query = [
        `startDate=${(this as any).formatDate(startOfCurrentMonth)}`,
        `endDate=${(this as any).formatDate(endOfCurrentMonth)}`,
      ].join("&");
      get({
        endpoint: "gringotts.api.v1.transactions.wallets.wallet-summary",
        query,
        cash_wallet_id: store.state.appModule.selectedEc?.cash_wallet_id,
      })
        .then((response) => {
          const data = response.walletDTOList[0];
          (this as any).walletSummary = {
            totalCredit: data?.totalCredit || 0,
            totalDebit: data?.totalDebit || 0,
            balance: data?.balance || 0,
            previousBalance:
              data?.balance - (data?.totalCredit - data?.totalDebit),
          };
        })
        .catch((err) => {
          // TODO
          /** Handle this */
          /** Show message to user if it is required */
          // console.error("Error fetching wallet summary:", err);
        })
        .finally(() => {
          (this as any).isLoading = false;
          (this as any).$store.commit("uiModule/hideLoadingModal", null, { root: true });
        });
    },
  },
  async mounted() {
    await (this as any).fetchSummary();
  },
  computed: {
    ...mapState("uiModule", {
      modalElement: "modalElement",
      isOnMobileDevice: "isOnMobileDevice",
      mobileAddonOption: "mobileAddonOption",
    }),
    ...mapState("appModule", {
      selectedEc: "selectedEc",
      breadcrumb: "breadcrumb",
    }),
    formattedBalance() {
      return (this as any).walletSummary && (this as any).walletSummary.balance
        ? formatCurrency((this as any).walletSummary.balance)
        : "0";
    },
  },
  watch: {
    selectedEc() {
      // Reload wallet summary when EC changes
      (this as any).fetchSummary();
    },
  },
});
